import DatabaseReference from '../platform/DatabaseReference';

export default class Keys extends DatabaseReference {
  get oloClientId() {
    return process.env.REACT_APP_ENVIRONMENT !== 'production'
      ? this.child('oloClientIdDevelopment')
      : this.child('oloClientId');
  }
}
